import {
  ALL_CANDIDATES,
  ASSESSMENT_LISTING_DATA,
  ASSESSMENT_LISTING_FETCH_LOADING,
  ASSESSMENT_LISTING_PAGINATION,
  CANDIDATE_VIEW_PAYLOAD,
  EDITED_STANDARDISED_JOB,
  HOLD_STANDARDISED_JOB,
  INTERVIEW_LISTING,
  INTERVIEW_SEARCHED_JOB,
  JOBS_POSTED_BY_RECRUITER,
  JOBS_POSTED_BY_RECRUITER_LOADING,
  POKE_CANDIDATE_LOADING,
  POST_JOB_LIMIT_ERROR,
  PUSH_TOP_JOB_WITH_CANDIDATES,
  RECOMMEND_JOB_PROFILES,
  RECRUITER_INTERVIEW_SEARCH_JOB_LOADING,
  RECRUITER_LOADING,
  REMOVE_TOP_JOBS_WITH_CANDIDATES,
  RESET_RECRUITER_STATE,
  TOP_JOBS_WITH_CANDIDATES,
  UPDATE_INTERVIEW_PAGINATION,
  UPDATE_MATCHING_CANDIDATES,
  UPDATE_TOP_MATCHING_CANDIDATES,
  VIEW_CANDIDATES_DYNAMICALLY,
  VIEW_CANDIDATES_PAGINATION,
  ASSESSMENT_LISTING_DATES_FILTER,
  DELETE_ASSESSMENT_LISTING_DATES_FILTER,
  SELECTED_CANDIDATE_INTERVIEW_REPORT,
  JOB_LISTING_PAGINATION,
  SET_AI_SESSION,
  CLEAR_AI_SESSION,
  ADD_CHAT_MESSAGE,
  UPDATE_CHAT_MESSAGE,
  CLEAR_CHAT_MESSAGES,
  JOB_LISTING_DATE_FILTER,
  JOB_LISTING_SEARCHED_JOB_FILTER,
  UPDARTE_INTERVIEW_LISTING_OBJECT,
  APP_ENG_ASSESSMENT_LISTING,
  APP_ANNOTATION_ASSESSMENT_LISTING,
  APP_AI_ASSESSMENT_LISTING,
  FETCH_APP_AI_ASSESSMENT,
  ACTIVE_ASSESSMENT,
  INCEPTION_STATS,
  APP_ENG_ASSESSMENT_LISTING_V2,
  APP_ENG_ASSESSMENT_LISTING_V3,
  APP_ENG_ASSESSMENT_LISTING_V4,
  APP_ANNOTATION_ASSESSMENT_LISTING_V2,
  APP_ANNOTATION_ASSESSMENT_LISTING_V3,
  FETCH_OVERALL_ASSESSMENTS,
  FETCH_CANCELLED_ASSESSMENTS_CANDIDATES,
  FETCH_REDO_ASSESSMENTS_CANDIDATES,
  GET_EMAIL_TEMPLATES,
  GET_SURVEY_QUESTIONS,
  DASHBOARD_COUNTS,
  FETCH_AI_ASSESSMENT_LISTING,
  DELETE_AI_ASSESSMENT,
  FETCH_ASSESSMENT_STATS,
  SET_AVAILABLE_APPLICANTS,
  SET_SELECTED_APPLICANT,
  SET_SELECTED_APPLICANTS,
  SET_APPLICANT_ASSESSMENTS,
  SET_APPLICANT_ASSESSMENT_DETAILS
} from "@/store/modules/recruiter/constants";
import {
  AllCandidates,
  CandidateViewPayload,
  InterviewListingResult,
  JobsWithCandidates,
  RecruiterState,
  SearchAutocompleteJobPayload,
  SetJobsMutationPayload,
  ViewCandidatesDynamically,
  ViewCandidatesPagination,
  InterviewListingCandidates,
  UpdateMatchingCandiadteMutationPayload,
  SearchedCandidate,
  UpdateZappyInterviewListingObjectPayload,
  AppEngAssessmentListing,
  AppAnnotationAssessmentListing,
  AppAiAssessmentListing,
  ActiveAssessment,
  InceptionStats,
  AppOverAllAssessmentListing,
  AssessmentVersions,
  CancelledAssessmentCandidates,
  RedoAssessmentCandidates,
  EmailTemplates,
  SurveyQuestions,
  DashboardCounts,
  AssessmentAiListing,
  AssessmentStats,
  AvailableApplicant,
  ApplicantAssessment,
  ApplicantAssessmentDetailsResponse
} from "@/store/modules/recruiter/interfaces";
import { AppAssessments } from "@/interfaces/data_objects/app_assessments";
import { Jobs, JobsWithSkillsGroup } from "@/interfaces/data_objects/jobs";
import { SearchJobObject } from "@/interfaces/shared/jobs/auto_complete_job_search";
import { AssessmentsListingResponse } from "@/interfaces/responses/assessments/assessments";

export default {
  [RECRUITER_LOADING]: (state: RecruiterState, payload: boolean): void => {
    state.loading = payload;
  },
  [JOBS_POSTED_BY_RECRUITER_LOADING]: (
    state: RecruiterState,
    payload: boolean
  ): void => {
    state.jobs_posted_loading = payload;
  },
  [JOBS_POSTED_BY_RECRUITER]: (
    state: RecruiterState,
    payload: SetJobsMutationPayload
  ): void => {
    state.jobs_posted.total = payload.total;
    state.jobs_posted.results = payload.results;
  },
  [TOP_JOBS_WITH_CANDIDATES]: (
    state: RecruiterState,
    payload: SetJobsMutationPayload
  ): void => {
    state.top_jobs_posted = payload;
  },
  [UPDATE_MATCHING_CANDIDATES]: (
    state: RecruiterState,
    payload: UpdateMatchingCandiadteMutationPayload
  ): void => {
    for (const [key, value] of Object.entries(payload.candidates_job_based)) {
      const job_index = state.jobs_posted.results.findIndex(
        (job: Jobs) => job.jid === parseInt(key)
      );
      if (job_index !== -1) {
        const result = value.filter((candidate: SearchedCandidate) => {
          if (candidate.score) return candidate.score > 0.2;
        });
        state.jobs_posted.results[job_index].candidates_loading = false;
        state.jobs_posted.results[job_index].matching_candidates = result;
      }
    }
  },
  [UPDATE_TOP_MATCHING_CANDIDATES]: (
    state: RecruiterState,
    payload: UpdateMatchingCandiadteMutationPayload
  ): void => {
    for (const [key, value] of Object.entries(payload.candidates_job_based)) {
      const job_index = state.top_jobs_posted.results.findIndex(
        (job: Jobs) => job.jid === parseInt(key)
      );
      if (job_index !== -1) {
        const result = value.filter((candidate: SearchedCandidate) => {
          if (candidate.score) return candidate.score > 0.2;
        });
        state.top_jobs_posted.results[job_index].candidates_loading = false;
        state.top_jobs_posted.results[job_index].matching_candidates = result;
      }
    }
  },
  /**
   * Removing job from top jobs with candidates data set if job_id is +ve
   */
  [REMOVE_TOP_JOBS_WITH_CANDIDATES]: (
    state: RecruiterState,
    job_id: number
  ): void => {
    state.top_jobs_posted.total -= 1;
    if (job_id >= 0) {
      state.top_jobs_posted.results = state.top_jobs_posted.results.filter(
        (v: JobsWithCandidates) => v.jid !== job_id
      );
    }
  },
  [VIEW_CANDIDATES_DYNAMICALLY]: (
    state: RecruiterState,
    payload: ViewCandidatesDynamically
  ): void => {
    state.view_candidates_dynamically = payload;
  },
  [PUSH_TOP_JOB_WITH_CANDIDATES]: (
    state: RecruiterState,
    payload: JobsWithCandidates
  ): void => {
    state.top_jobs_posted.results.pop();
    state.top_jobs_posted.results.unshift(payload);
    state.top_jobs_posted.total += 1;
  },
  // Updating recommend job profiles
  [RECOMMEND_JOB_PROFILES]: (state: RecruiterState, payload: Jobs[]): void => {
    state.recommend_job_profiles = payload;
  },
  [RESET_RECRUITER_STATE]: (state: RecruiterState): void => {
    state.loading = false;
    state.jobs_posted_loading = false;
    state.post_job_limit_error = "";
    state.poke_candidate_loading = false;
    state.add_standardised_job = null;
    state.edited_Standardised_job = false;
    state.view_candidates_dynamically = {
      active: false,
      loading: false,
      job_id: null,
      job_title: "",
      skill: "",
      user_ids: []
    };
    // Using in job listing page
    state.jobs_posted = {
      total: 0,
      results: [],
      pagination: 1,
      date_filter: [],
      searched_job_title: null
    };
    // Using to display jobs in dashboard
    state.top_jobs_posted = { total: 0, results: [] };
    state.recommend_job_profiles = [];
    state.candidate_view_payload = null;
    state.all_candidates = {
      results: [],
      total: 0,
      filtered_count: -1
    };
    state.interviews = {
      search_job_loading: false,
      searched_job: null,
      pagination: 1,
      interview_listing: new Map(),
      selected_candidate: []
    };
    state.view_candidates_pagination = {
      pagination: 1
    };
    state.assessment_listing = {
      fetch_loading: false,
      pagination: 1,
      selected_dates: [],
      data: {
        total: 0,
        results: []
      }
    };
    state.inseption_stats = {
      annotationAssessment: "0",
      englishAssessment: "0",
      users: "0",
      allUsers: "0"
    };
    state.eng_assessment_listing = {
      limit: 10,
      page: 1,
      total: 0,
      results: [],
      selected_dates: {
        date_picker_menu: false,
        date_range_value: "",
        date_filter: []
      },
      selected_candidates: []
    };
    state.annotation_assessment_listing = {
      limit: 10,
      page: 1,
      total: 0,
      results: [],
      selected_dates: {
        date_picker_menu: false,
        date_range_value: "",
        date_filter: []
      },
      selected_candidates: []
    };
    state.overall_assessment_listing = {
      page: 1,
      limit: 10,
      total: 0,
      selected_dates: {
        date_picker_menu: false,
        date_range_value: "",
        date_filter: []
      },
      results: [],
      selected_candidates: [],
      score_filter: "both",
      average_score_filter: [0, 100],
      english_assessment_filter: [0, 100],
      annotation_assessment_filter: [0, 100],
      assessment_versions: [AssessmentVersions.VERSION_4],
      eid_name_filter: "Name"
    };
    state.eng_assessment_listing_v3 = {
      limit: 10,
      page: 1,
      total: 0,
      results: [],
      selected_dates: {
        date_picker_menu: false,
        date_range_value: "",
        date_filter: []
      },
      selected_candidates: []
    };
    state.eng_assessment_listing_v4 = {
      limit: 10,
      page: 1,
      total: 0,
      results: [],
      selected_dates: {
        date_picker_menu: false,
        date_range_value: "",
        date_filter: []
      },
      selected_candidates: []
    };
    state.annotation_assessment_listing_v3 = {
      limit: 10,
      page: 1,
      total: 0,
      results: [],
      selected_dates: {
        date_picker_menu: false,
        date_range_value: "",
        date_filter: []
      },
      selected_candidates: []
    };
  },
  [CANDIDATE_VIEW_PAYLOAD]: (
    state: RecruiterState,
    payload: CandidateViewPayload | null
  ): void => {
    state.candidate_view_payload = payload;
  },
  [ALL_CANDIDATES]: (state: RecruiterState, payload: AllCandidates): void => {
    state.all_candidates = payload;
  },
  /**
   * Set poke candidate loading
   * @param {boolean} payload: true to enable loading, false to cancel loading
   */
  [POKE_CANDIDATE_LOADING]: (state: RecruiterState, payload: boolean): void => {
    state.poke_candidate_loading = payload;
  },
  [POST_JOB_LIMIT_ERROR]: (state: RecruiterState, payload: string): void => {
    state.post_job_limit_error = payload;
  },
  [HOLD_STANDARDISED_JOB]: (
    state: RecruiterState,
    payload: JobsWithSkillsGroup | null
  ): void => {
    state.add_standardised_job = payload;
  },
  /**
   * Set searched job, used to fetch all interviewers of specific job
   * @param state
   * @param payload
   */
  [INTERVIEW_SEARCHED_JOB]: (
    state: RecruiterState,
    payload: SearchJobObject | null
  ): void => {
    state.interviews.searched_job = payload;
  },
  [INTERVIEW_LISTING]: (
    state: RecruiterState,
    payload: Map<number, InterviewListingResult>
  ): void => {
    state.interviews.interview_listing = payload;
  },
  [RECRUITER_INTERVIEW_SEARCH_JOB_LOADING]: (
    state: RecruiterState,
    payload: boolean
  ): void => {
    state.interviews.search_job_loading = payload;
  },
  [VIEW_CANDIDATES_PAGINATION]: (
    state: RecruiterState,
    payload: ViewCandidatesPagination
  ): void => {
    state.view_candidates_pagination = payload;
  },
  [UPDATE_INTERVIEW_PAGINATION]: (
    state: RecruiterState,
    payload: number
  ): void => {
    state.interviews.pagination = payload;
  },
  // For holding that either user edit standardised job or not during job posting
  [EDITED_STANDARDISED_JOB]: (
    state: RecruiterState,
    payload: boolean
  ): void => {
    state.edited_Standardised_job = payload;
  },
  [ASSESSMENT_LISTING_FETCH_LOADING]: (
    state: RecruiterState,
    payload: boolean
  ): void => {
    state.assessment_listing.fetch_loading = payload;
  },
  [ASSESSMENT_LISTING_PAGINATION]: (
    state: RecruiterState,
    payload: number
  ): void => {
    state.assessment_listing.pagination = payload;
  },
  [ASSESSMENT_LISTING_DATA]: (
    state: RecruiterState,
    payload: AssessmentsListingResponse.Root
  ): void => {
    state.assessment_listing.data = payload;
  },
  [ASSESSMENT_LISTING_DATES_FILTER]: (
    state: RecruiterState,
    payload: string[]
  ): void => {
    state.assessment_listing.selected_dates = payload;
  },
  [DELETE_ASSESSMENT_LISTING_DATES_FILTER]: (state: RecruiterState): void => {
    state.assessment_listing.selected_dates = [];
  },
  [SELECTED_CANDIDATE_INTERVIEW_REPORT]: (
    state: RecruiterState,
    candidate: InterviewListingCandidates[]
  ): void => {
    state.interviews.selected_candidate = candidate;
  },
  [JOB_LISTING_PAGINATION]: (state: RecruiterState, page: number): void => {
    state.jobs_posted.pagination = page;
  },
  [JOB_LISTING_DATE_FILTER]: (state: RecruiterState, dates: string[]): void => {
    state.jobs_posted.date_filter = dates;
  },
  [JOB_LISTING_SEARCHED_JOB_FILTER]: (
    state: RecruiterState,
    title: SearchAutocompleteJobPayload | null
  ): void => {
    state.jobs_posted.searched_job_title = title;
  },
  [UPDARTE_INTERVIEW_LISTING_OBJECT]: (
    state: RecruiterState,
    payload: UpdateZappyInterviewListingObjectPayload
  ): void => {
    const obj = state.interviews.interview_listing.get(payload.job_id);
    if (!obj) return;
    obj.zappy_job_id = payload.zappy_job_id;
    state.interviews.interview_listing.set(payload.job_id, obj);
  },
  // Setting english assessment listing
  [APP_ENG_ASSESSMENT_LISTING]: (
    state: RecruiterState,
    payload: AppEngAssessmentListing
  ): void => {
    state.eng_assessment_listing = payload;
  },
  // Setting english assessment listing v2
  [APP_ENG_ASSESSMENT_LISTING_V2]: (
    state: RecruiterState,
    payload: AppEngAssessmentListing
  ): void => {
    state.eng_assessment_listing_v2 = payload;
  },
  // Setting annotation assessment listing
  [APP_ANNOTATION_ASSESSMENT_LISTING]: (
    state: RecruiterState,
    payload: AppAnnotationAssessmentListing
  ): void => {
    state.annotation_assessment_listing = payload;
  },
  // Setting AI assessment listing
  [APP_AI_ASSESSMENT_LISTING]: (
    state: RecruiterState,
    payload: AppAiAssessmentListing
  ): void => {
    state.app_ai_assessment_listing = payload;
  },
  [FETCH_APP_AI_ASSESSMENT]: (
    state: RecruiterState,
    payload: AppAssessments.AiAssessmentResults
  ): void => {
    console.log("payload", payload);
    state.fetch_app_ai_assessment = payload;
  },
  // Setting annotation assessment listing
  [APP_ANNOTATION_ASSESSMENT_LISTING_V2]: (
    state: RecruiterState,
    payload: AppAnnotationAssessmentListing
  ): void => {
    state.annotation_assessment_listing_v2 = payload;
  },
  // Setting english assessment listing v3
  [APP_ENG_ASSESSMENT_LISTING_V3]: (
    state: RecruiterState,
    payload: AppEngAssessmentListing
  ): void => {
    state.eng_assessment_listing_v3 = payload;
  },
  // Setting english assessment listing v4
  [APP_ENG_ASSESSMENT_LISTING_V4]: (
    state: RecruiterState,
    payload: AppEngAssessmentListing
  ): void => {
    state.eng_assessment_listing_v4 = payload;
  },
  // Setting annotation assessment listing v3
  [APP_ANNOTATION_ASSESSMENT_LISTING_V3]: (
    state: RecruiterState,
    payload: AppAnnotationAssessmentListing
  ): void => {
    state.annotation_assessment_listing_v3 = payload;
  },
  [ACTIVE_ASSESSMENT]: (
    state: RecruiterState,
    payload: ActiveAssessment
  ): void => {
    state.active_assessment = payload;
  },
  [INCEPTION_STATS]: (state: RecruiterState, payload: InceptionStats): void => {
    state.inseption_stats = payload;
  },
  [FETCH_OVERALL_ASSESSMENTS]: (
    state: RecruiterState,
    payload: AppOverAllAssessmentListing
  ): void => {
    state.overall_assessment_listing = payload;
  },
  [FETCH_CANCELLED_ASSESSMENTS_CANDIDATES]: (
    state: RecruiterState,
    payload: CancelledAssessmentCandidates
  ): void => {
    state.cancelled_assessment_candidates = payload;
  },

  [FETCH_REDO_ASSESSMENTS_CANDIDATES]: (
    state: RecruiterState,
    payload: RedoAssessmentCandidates
  ): void => {
    state.redo_assessment_candidates = payload;
  },
  [GET_EMAIL_TEMPLATES]: (
    state: RecruiterState,
    payload: EmailTemplates[]
  ): void => {
    state.email_templates = payload;
  },
  [GET_SURVEY_QUESTIONS]: (
    state: RecruiterState,
    payload: SurveyQuestions[]
  ): void => {
    state.survey_questions = payload;
  },
  [DASHBOARD_COUNTS]: (
    state: RecruiterState,
    payload: DashboardCounts
  ): void => {
    state.dashboard_counts = payload;
  },
  [FETCH_AI_ASSESSMENT_LISTING]: (
    state: RecruiterState,
    payload: AssessmentAiListing[]
  ): void => {
    state.ai_assessment_listing = payload;
  },
  [DELETE_AI_ASSESSMENT]: (
    state: RecruiterState,
    assessmentId: number
  ): void => {
    state.ai_assessment_listing = state.ai_assessment_listing.filter(
      (assessment) => assessment.id !== assessmentId
    );
  },
  [FETCH_ASSESSMENT_STATS]: (
    state: RecruiterState,
    payload: AssessmentStats
  ): void => {
    state.assessment_stats = payload;
  },
  [SET_AI_SESSION]: (
    state: RecruiterState,
    payload: {
      session_id: string;
      session_message: string;
    }
  ): void => {
    state.ai_session.session_id = payload.session_id;
    state.ai_session.session_message = payload.session_message;
  },
  [CLEAR_AI_SESSION]: (state: RecruiterState): void => {
    state.ai_session.session_id = null;
    state.ai_session.session_message = "";
    state.ai_session.chat_messages = [];
  },
  [ADD_CHAT_MESSAGE]: (
    state: RecruiterState,
    payload: {
      type: "user" | "ai";
      text: string;
      time: string;
      loading?: boolean;
    }
  ): void => {
    state.ai_session.chat_messages.push(payload);
  },
  [UPDATE_CHAT_MESSAGE]: (
    state: RecruiterState,
    payload: {
      index: number;
      message: {
        type: "user" | "ai";
        text: string;
        time: string;
        loading?: boolean;
      };
    }
  ): void => {
    if (
      payload.index >= 0 &&
      payload.index < state.ai_session.chat_messages.length
    ) {
      state.ai_session.chat_messages[payload.index] = payload.message;
    }
  },
  [CLEAR_CHAT_MESSAGES]: (state: RecruiterState): void => {
    state.ai_session.chat_messages = [];
  },
  [SET_AVAILABLE_APPLICANTS]: (
    state: RecruiterState,
    payload: AvailableApplicant[]
  ): void => {
    state.available_applicants = payload;
  },
  [SET_SELECTED_APPLICANT]: (
    state: RecruiterState,
    payload: AvailableApplicant | null
  ): void => {
    state.selected_applicant = payload;
  },
  [SET_SELECTED_APPLICANTS]: (
    state: RecruiterState,
    payload: AvailableApplicant[]
  ): void => {
    state.selected_applicants = payload;
  },
  [SET_APPLICANT_ASSESSMENTS]: (
    state: RecruiterState,
    payload: ApplicantAssessment[]
  ): void => {
    state.applicant_assessments = payload;
  },
  [SET_APPLICANT_ASSESSMENT_DETAILS]: (
    state: RecruiterState,
    payload: ApplicantAssessmentDetailsResponse
  ): void => {
    state.applicant_assessment_details = payload;
  }
};
